import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import SessionContext from '../context/SessionProvider';

interface UnauthenticatedRouteProps {
  isGuestRoute?: boolean;
  children: React.ReactNode;
}

export default function UnauthenticatedRoute({ isGuestRoute = false, children }: UnauthenticatedRouteProps) {
  const session = useContext(SessionContext);
  if (!session.isAuthenticated || isGuestRoute) {
    return children;
  }
  return <Navigate to="/in/folder/root" replace />;
}
